"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const Button_1 = require("../Button");
const Overlay_1 = require("../Overlay");
const Target_1 = require("../Target");
const Notification = ({ buttonClickHandler, buttonText, closeDelay, icon, isOpen, onDismiss, showX = true, status = "default", subText, text }) => {
    const [timeoutId, setTimeoutId] = react_1.default.useState(null);
    const statusColors = {
        default: {
            iconColor: "stroke01"
        },
        information: {
            iconColor: "notification01",
            primaryBackground: "notification01",
            secondaryBackground: "notification03"
        },
        success: {
            iconColor: "success01",
            primaryBackground: "success01",
            secondaryBackground: "success03"
        },
        warning: {
            iconColor: "warning01",
            primaryBackground: "warning01",
            secondaryBackground: "warning03"
        },
        error: {
            iconColor: "error01",
            primaryBackground: "error01",
            secondaryBackground: "error03"
        }
    };
    const clickingContent = react_1.default.useRef(false);
    const handleClickOutside = react_1.default.useCallback(() => {
        if (!clickingContent.current) {
            onDismiss();
        }
        clickingContent.current = false;
    }, [onDismiss]);
    react_1.default.useEffect(() => {
        const setCloseTimer = () => {
            if (!timeoutId) {
                const newTimeoutId = setTimeout(() => {
                    onDismiss();
                    setTimeoutId(null);
                }, closeDelay);
                setTimeoutId(newTimeoutId);
            }
        };
        if (isOpen && closeDelay) {
            setCloseTimer();
        }
        else if (timeoutId) {
            clearTimeout(timeoutId);
            setTimeoutId(null);
        }
    }, [closeDelay, isOpen, onDismiss, timeoutId]);
    return (react_1.default.createElement(Overlay_1.Overlay, { visible: isOpen, onDismiss: onDismiss, sx: {
            alignItems: "center",
            cursor: "pointer",
            display: "flex"
        } },
        react_1.default.createElement(foundations_1.Grid, { initial: true, onClick: handleClickOutside },
            react_1.default.createElement(foundations_1.GridColumn, { size: [4, 6, 8], sx: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100vh"
                }, push: [0, 1, 2] },
                react_1.default.createElement(foundations_1.Box, { onClick: () => {
                        clickingContent.current = true;
                    }, sx: {
                        backgroundColor: "background01",
                        borderColor: "stroke02",
                        borderRadius: "large",
                        boxShadow: "boxShadow01",
                        cursor: "initial",
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        p: 4
                    } },
                    icon && (react_1.default.createElement(foundations_1.Box, { sx: {
                            backgroundColor: statusColors[status].secondaryBackground,
                            p: status !== "default" ? 2 : 0,
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: 12,
                            height: 12,
                            flexShrink: 0
                        } },
                        react_1.default.createElement(foundations_1.Box, { sx: {
                                width: 8,
                                height: 8,
                                opacity: 0.2,
                                backgroundColor: statusColors[status].primaryBackground,
                                position: "absolute",
                                borderRadius: "50%"
                            } }),
                        react_1.default.createElement(foundations_1.Icon, { icon: icon, sx: {
                                color: statusColors[status].iconColor
                            } }))),
                    react_1.default.createElement(foundations_1.Box, { sx: {
                            display: "flex",
                            flexDirection: "column",
                            alignSelf: "center",
                            alignItems: "flex-start",
                            gap: 4,
                            px: 2
                        } },
                        react_1.default.createElement(foundations_1.Box, { sx: { display: "flex", flexDirection: "column", gap: 1 } },
                            react_1.default.createElement(foundations_1.Text, { size: "md", variant: "bold" }, text),
                            subText && react_1.default.createElement(foundations_1.Text, null, subText)),
                        buttonText && (react_1.default.createElement(foundations_1.Box, { sx: {
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 3
                            } },
                            react_1.default.createElement(foundations_1.Box, { sx: { ml: -2 } },
                                react_1.default.createElement(Button_1.Button, { onClick: buttonClickHandler, variant: "tertiary", color: "link01", sx: { ml: -1 } }, buttonText))))),
                    showX && (react_1.default.createElement(foundations_1.Box, { sx: { flexShrink: 0, pl: 2 } },
                        react_1.default.createElement(Target_1.Target, { "aria-label": "Close notification", onClick: () => {
                                clickingContent.current = true;
                                onDismiss();
                            } },
                            react_1.default.createElement(foundations_1.Icon, { icon: "x", size: "sm", sx: { color: "stroke01" } })))))))));
};
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map